<template>
    <div class="blog-page-wrapper">
         <!-- loading... -->
        <p v-if="isPageLoading" class="loading"> در حال بارگذاری ... </p>

        <!-- error -->
        <div v-if="pageError" class="error">
            <p>خطا در دریافت اطلاعات .</p>
            <button @click="getLastPosts">تلاش مجدد</button>
        </div>

        <div v-else class="blog-page-main">
            <img v-show="postContent.iu" :src="postContent.iu" class="blog-page-img" />
            <h1 class="blog-page-title">{{postContent.t}}</h1>
            <div ref="blogContent" v-html="postContent.b" class="blog-page-content"></div>
            <div class="blog-page-date">
                <img v-show="postContent.pc" src="../assets/images/clock.svg" class="icon" />
                <span>{{postContent.pc}}</span>
            </div>
            <ModalBox :isModalOpen="showModal" @close="closeModal"></ModalBox>
        </div>
        <router-link to="/blog" v-if="!isPageLoading && !pageError" class="btn btn--secondary blog-page-btn">بازگشت به لیست</router-link>
    </div>

</template>

<script>
import { ref, computed, watch, inject, onMounted, nextTick } from "vue";
import axios from 'axios';
import ModalBox from './ModalBox.vue';
import { useModal } from '@/useModal';
import { useRoute } from 'vue-router';

export default {
    name: "BlogPage",
    components: {
        ModalBox,
    },
    setup() {
        const { showModal, openModal, closeModal } = useModal();

        const updateMetaTag = inject('updateMetaTag');
        const updateOGTag = inject('updateOGTag');
        const updateCanonicalLink = inject('updateCanonicalLink');

        const isPageLoading = ref(true);
        const pageError = ref(false);
        const route = useRoute();

        const blogContent = ref(null);
        const postContent = ref([]);
        const postTitle = computed(() => postContent.value.t || "");
        const postDesc =  computed(() => postContent.value.s || "");
        const postCode =  computed(() => postContent.value.p || "");
        const postImage = computed(() => postContent.value.iu || "");

        function getPostContent(){
            isPageLoading.value = true;
            pageError.value = false;
            axios({
                method: 'POST',
                url: `${process.env.VUE_APP_ONCLICK_API_DOMAIN}/blog/${route.params.p}`,
            }).then(response => {
                postContent.value = response.data;
                document.title = ` ${response.data.t} | آن کلیک`;
                isPageLoading.value = false;
                }).catch(err => {
                    console.error('خطا در دریافت اطلاعات:', err);
                    isPageLoading.value = false;
                    pageError.value = true;
            });
        }

        watch(() => postContent.value, async () => {
          await nextTick();
          const blogModal = blogContent.value.querySelector("p.blog-consult-modal");
          if (blogModal) {
            blogModal.addEventListener("click", (event) => {
              event.stopPropagation();
              openModal();
            });
          }
        });

        onMounted(() => {
            getPostContent();
            watch(postTitle, (newTitle) => {
                updateMetaTag('title', newTitle);
                updateOGTag('title', newTitle);
            });
            watch(postDesc, (newDesc) => {
                updateMetaTag('description', newDesc);
                updateOGTag('description', newDesc);
            });
            watch(postCode, (newCode) => {
                updateOGTag('url', `https://onclick.ir/post/${newCode}`);
                updateCanonicalLink(`https://onclick.ir/blog/${newCode}`);
            });
            watch(postImage, (newImage) => {
                updateOGTag('image', newImage);
            });
            updateOGTag('type', 'article');
        });

        return {
            postContent,
            blogContent,
            pageError,
            isPageLoading,
            showModal,
            openModal,
            closeModal,
        };
    }
}
</script>

<style>
.blog-page-wrapper img {
    max-width: 80%;
    height: auto;
}

.blog-page-wrapper ul {
   list-style: disc;
   padding-right: 30px;
}

.blog-page-wrapper {
    width: 80%;
    margin-inline: auto;
    margin-block: 50px 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 70px;
}

.blog-page-main {
    overflow: hidden;
}

.blog-page-img {
    aspect-ratio: 500 / 400;
    width: 50%;
    max-width: 500px !important;
    object-fit: contain;
    display: block;
    float: left;
    margin-right: 20px;
    margin-bottom: 10px;
}

.blog-page-title {
  font-size: 24px;
}

.blog-page-title,
.blog-page-content h2 {
    margin-bottom: 8px;
}

.blog-page-title,
.blog-page-content h2 span,
.blog-page-content h2 strong,
.blog-page-content p strong{
    font-family: IRANYekan-Bold;
}

.blog-page-content h2 span,
.blog-page-content h2 strong {
    font-size: 22px;
}

.blog-page-content p {
    margin-bottom: 20px;
    line-height: 30px;
}

.blog-page-content li {
    margin-bottom: 10px;
}

.blog-page-content p strong,
.blog-page-content a {
    font-size: 20px;
}

.blog-page-content a,
p.blog-consult-modal {
    color: var(--main-pink);
}

.blog-page-date {
    float: left;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #737373;
    gap: 6px;
}

.blog-page-date span {
    font-size: 16px !important;
}

.blog-page-btn {
    width: fit-content;
}

p.blog-consult-modal {
    cursor: pointer;
}

@media screen and (min-width: 1921px) {
    .blog-page-wrapper {
        width: 1545px;
    }
}

@media screen and (max-width: 1024px) {
    .blog-page-wrapper {
        margin-bottom: 160px;
        gap: 50px;
    }
}

@media screen and (max-width: 768px) {
    .blog-page-wrapper {
        margin-top: 30px;
    }

    .blog-page-img{
        float: none;
        margin-inline: auto;
        margin-bottom: 20px;
    }

    .blog-page-title {
        font-size: 22px;
    }

    .blog-page-content h2 span, .blog-page-content h2 strong {
        font-size: 18px !important;
    }

    .blog-page-content p,
    .blog-page-content p span,
    .blog-page-content p strong,
    .blog-page-content a,
    .blog-page-content li span {
        font-size: 16px !important;
    }

    .blog-page-date img {
        width: 20px;
    }
}

@media screen and (max-width: 425px) {
    .blog-page-img{
        width: 200px;
    }

     .blog-page-date span {
        font-size: 14px !important;
    }
}
</style>